import { connect } from "react-redux";
import StaffRoutes from "./staff-routes";
import { onList, onSearchClear } from "../actions";

const mapStateToProps = ({ profile }) => ({
	role: profile.role,
	supervisingStaffList: profile.supervisingStaffList,
});

const mapDispatchToProps = {
	onGetStaffList: onList,
	onSearchClear: onSearchClear,
};

export default connect(mapStateToProps, mapDispatchToProps)(StaffRoutes);
